<div class="indicador">
  <div class="indicador__icon-container">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
  <div class="indicador__info">
    <span class="indicador__label">{{ label }}</span>
    <span class="indicador__value">{{ value }}{{ suffix }}</span>
  </div>
</div>
